<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span *ngIf="getTenant($.row[$.adata.fetch_key]) as tenant">{{tenant.name_primary_language || tenant.name_secondary_language}}</span>
</ng-container>
